<template>
  <div>
    <viewTable
      ref="viewTable"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="stockDetails/kingdee"
      :table-select="false"
      @reset="resetHandle"
      :selReset="true"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="$refs.viewTable.loadData(1)">
          <el-form-item label="生产中心">
            <el-select v-model="workCenterName" @change="selectChange">
              <el-option v-for="item in workCenterList" :key="item.pkId" :label="item.workCenterName" :value="item.pkId" />
            </el-select>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable />
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
export default {
  components: { viewTable },
  data() {
    return {
      workCenterName: "",
      filter: {
        materialNo: "",
        materialName: "",
        warehouseNo: "",
      },
      columnsProperty: [
        {
          key: "ownerName",
          width: 140,
          tooltip: true,
          align: "center",
        },
        {
          tooltip: true,
          key: "warehouseNo",
          width: 100,
          align: "center",
        },
        {
          key: "warehouseName",
          width: 140,
          tooltip: true,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialNo",
          width: 120,
          align: "center",
        },
        {
          key: "materialName",
          minWidth: 360,
          tooltip: true,
        },
        {
          key: "specification",
          width: 180,
          tooltip: true,
        },
        {
          tooltip: true,
          key: "baseQuantity",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialHeight",
          width: 100,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialWidth",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialLength",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "materialWeight",
          width: 90,
          align: "center",
        },
        {
          tooltip: true,
          key: "unitName",
          width: 80,
          align: "center",
        },
      ],
      workCenterList: [],
    };
  },

  mounted() {
    this.getWorkCenters();
  },

  methods: {
    // 获取班组生产中心
    getWorkCenters() {
      this.$http.get("basic", "workCenters/employee/list").then((res) => {
        if (res.success) {
          this.workCenterList = res.data;
          this.workCenterName = res.data[0].workCenterName;
          this.filter.warehouseNo = res.data[0].warehouseNo;
        }
      });
    },

    selectChange(value) {
      const arr = this.workCenterList.filter((item) => item.pkId === value);
      this.filter.warehouseNo = arr[0].warehouseNo;
    },

    resetHandle(filter) {
      this.filter = filter;
      this.getWorkCenters();
    },
  },
};
</script>
